// extracted by mini-css-extract-plugin
export var container = "landing-module--container--11utD";
export var wrapper = "landing-module--wrapper--2w8ru";